import * as fragment from "./cms";
import { examEditorItemFields } from "./exam";

export const resourceEditorFields = `
${fragment.base}
${fragment.baseResource}
${fragment.meta}
schemaVersion
file {
  ${fragment.file}
}
dimensions {
  ${fragment.dimensions}
}
${fragment.content}
interaction
scoring
creatorId
editorId
reviewerId
data
deliveryMediaType
reviewer {
  ${fragment.user}
}
assigneeId
assignee {
  ${fragment.user}
}
questionIds
questions {
  ${examEditorItemFields}
}
config
${fragment.blueprint}
alignmentIds
alignments {
  items {
    ${fragment.objective}
  }
  nextToken
}
contextIds
contexts {
  items {
    ${fragment.context}
  }
  nextToken
}
bank {
  id
  sk
  name
  description
  workspace {
    ${fragment.workspace}
  }
  user {
    ${fragment.user}
  }
}
editor {
  ${fragment.user}
}
creator {
  ${fragment.user}
}
isUserWatcher
isUserFavorite
isUnlisted
visibility
`;
